import { render, staticRenderFns } from "./MapMarkerHotel.vue?vue&type=template&id=54bcb0a6&"
import script from "./MapMarkerHotel.vue?vue&type=script&lang=js&"
export * from "./MapMarkerHotel.vue?vue&type=script&lang=js&"
import style0 from "./MapMarkerHotel.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports